export const formName = 'choosePartner';

export const ACTION_PREFIX = 'choose-partner';

export enum ChoosePartnerField {
    PartnerId = 'partnerId',
}

export const localStorageKey = 'partner/partnerId';
